import React from "react";
import Section from "../Section";
import BannerSectionStyle5 from "../Section/BannerSection/BannerSectionStyle5";
import { pageTitle } from "../../helpers/PageTitle";

export default function LifeAtCelbion() {
  pageTitle("Life at Celbion");
  return (
    <>
      <BannerSectionStyle5
        bgUrl="/images/about/banner_bg.jpg"
        imgUrl="/images/doctors/banner_img.png"
        
        title="LIFE AT Celbion"
        subTitle="Dare to Rise Higher"
      />

      <Section topMd={80} topLg={80} bottomMd={60} bottomLg={60}>
        <div className="container">
          <div className="row justify-content-center">
            <div className="col-lg-8">
              <div className="cs_section_heading cs_text_center">
                <h2 className="cs_title">LIFE AT Celbion</h2>
                <p>
                  We believe that unwavering dedication to excellence is the
                  foundation of exceptional performance. Celbion Healthcare’s
                  Annual Meet is a special and rewarding experience created to
                  recognize and celebrate our top achievers, our appreciation
                  for hard work and commitment to deeply embedded in our
                  culture.
                </p>
              </div>
            </div>
          </div>

          <div className="row cs_mt_40">
            <div className="col-md-6 col-lg-6">
              <div className="cs_blog_card">
                <div className="cs_blog_card_thumb">
                  <img
                    src="/images/about/Meeting.png"
                    alt="Annual Meeting"
                  />
                </div>
                <div className="cs_blog_card_body">
                  <h4 className="cs_blog_title">Celbion Annual Meeting</h4>
                </div>
              </div>
            </div>

            <div className="col-md-6 col-lg-6">
              <div className="cs_blog_card">
                <div className="cs_blog_card_thumb">
                  <img src="/images/about/Award.png" alt="Award" />
                </div>
                <div className="cs_blog_card_body">
                  <h4 className="cs_blog_title">Celbion Award of the Year</h4>
                </div>
              </div>
            </div>

            <div className="col-md-6 col-lg-6 cs_mt_30">
              <div className="cs_blog_card">
                <div className="cs_blog_card_thumb">
                  <img
                    src="/images/about/Meeting.png"
                    alt="Annual Meeting"
                  />
                </div>
                <div className="cs_blog_card_body">
                  <h4 className="cs_blog_title">Celbion Annual Meeting</h4>
                </div>
              </div>
            </div>

            <div className="col-md-6 col-lg-6 cs_mt_30">
              <div className="cs_blog_card">
                <div className="cs_blog_card_thumb">
                  <img src="/images/about/Award.png" alt="Award" />
                </div>
                <div className="cs_blog_card_body">
                  <h4 className="cs_blog_title">Celbion Award of the Year</h4>
                </div>
              </div>
            </div>
          </div>
        </div>
      </Section>
    </>
  );
}
